module.exports = __webpack_public_path__ + "img/board_bot.a7f42f43.png";